// @flow
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import CartTemplateContainer from 'containers/cart/CartTemplateContainer';
import UserTemplate from 'components/user/UserTemplate';
import PageTemplate from 'components/base/PageTemplate';

type Props = {};

class Cart extends Component<Props> {
  render() {
    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <UserTemplate>
          <Helmet>
            <title>장바구니 | 캐시바이</title>
          </Helmet>
          <CartTemplateContainer />
        </UserTemplate>
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default Cart;



// WEBPACK FOOTER //
// ./src/pages/Cart.js